.lmsIcon > svg {
	width: 100%;
	height: 100%;
}

.lmsIcon svg image {
	width: 100%;
	height: 100%;
}
